import theme from './theme/en_US';
import profile from './profile/en_US';
import member from './member/en_US';
import organization from './organization/en_US';
import console from './console/en_US';
import aws from './aws/en_US';
import activity from './activity/en_US';
export default {
  ...theme,
  ...profile,
  ...console,
  ...organization,
  ...member,
  ...aws,
  ...activity,
};
